import { useEffect, useState } from "react";
import { FileText } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Panel, SectionLabel } from "@/components/common/ui-kit";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const QuoteIntroPanel = () => {
  const { can } = useAuth();
  const [d, setD] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/sales/quote-pdf-intro").then((r) => { setD(r.data); setText(r.data.text); }).catch(() => {}); }, []);
  if (!d) return null;
  const edit = can("documents:manage");
  const save = async (value) => {
    setBusy(true);
    try { const r = (await api.put("/sales/quote-pdf-intro", { text: value })).data; setD(r); setText(r.text); toast.success("Testo introduttivo salvato: vale per i prossimi PDF offerta."); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Panel className="p-5 lg:col-span-3" data-testid="quote-intro-panel">
      <div className="mb-2 flex items-center gap-2"><FileText className="h-4 w-4 text-slate-400" /><SectionLabel>PDF offerta · testo sotto l'oggetto</SectionLabel></div>
      <p className="mb-3 text-xs text-slate-500">Compare nella prima pagina di ogni PDF offerta, sotto l'oggetto. Gli a capo vengono mantenuti.{d.custom ? "" : " Ora è in uso il testo predefinito."}</p>
      <Textarea rows={4} maxLength={2000} value={text} disabled={!edit || busy} onChange={(e) => setText(e.target.value)} data-testid="quote-intro-text" />
      {edit && <div className="mt-3 flex flex-wrap gap-2">
        <Button disabled={busy || !text.trim() || text === d.text} onClick={() => save(text)} data-testid="quote-intro-save">Salva</Button>
        <Button variant="outline" disabled={busy || !d.custom} onClick={() => save("")} data-testid="quote-intro-reset">Ripristina predefinito</Button>
      </div>}
    </Panel>
  );
};
